// extracted by mini-css-extract-plugin
export var close = "InfoGrid-module--close--5f27d";
export var container = "InfoGrid-module--container--16312";
export var makeColumns = "InfoGrid-module--makeColumns--b3261";
export var question = "InfoGrid-module--question--88867";
export var questionContainer = "InfoGrid-module--questionContainer--02a71";
export var tipContainer = "InfoGrid-module--tipContainer--cc53f";
export var tipQuestion = "InfoGrid-module--tipQuestion--9927f";
export var tipQuestionIcon = "InfoGrid-module--tipQuestionIcon--b7d4c";